import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Icon } from 'antd';
import PropTypes from 'prop-types';

import { USER_ROLES } from '@sp/config/db_const';

import s from './style.less';

class NavBar extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    location: PropTypes.object,
    withPadding: PropTypes.bool,
    userRole: PropTypes.number,
  };

  routes = {
    [USER_ROLES.PROVIDER]: [
      {
        path: '/provider',
        content: <div>Home</div>,
        exact: true,
        icon: 'home',
      },
      {
        path: '/provider/new-plan',
        content: <div>Create new plan</div>,
        icon: 'plus',
      },
      {
        path: '/provider/plans',
        content: <div>My plans</div>,
        icon: 'file-text',
      },
      {
        path: '/provider/bookings',
        content: <div>Manage bookings</div>,
        icon: 'calendar',
      },
      {
        path: '/provider/my-details',
        content: <div>My Details</div>,
        icon: 'user',
      },
    ],
    [USER_ROLES.CUSTOMER]: [
      {
        path: '/customer/plans',
        content: <div>Home</div>,
        icon: 'home',
      },
      {
        path: '/customer/docs',
        content: <div>View Docs</div>,
        icon: 'file-text',
      },
      {
        path: '/customer/payments',
        content: <div>Payments</div>,
        icon: 'pie-chart',
      },
      {
        path: '/customer/my-details',
        content: <div>My Details</div>,
        icon: 'user',
      },
    ],
    [USER_ROLES.ADMIN]: [
      {
        path: '/admin',
        exact: true,
        content: <div>Home</div>,
        icon: 'home',
      },
      {
        path: '/admin/claim',
        exact: true,
        content: <div>Claim</div>,
        icon: 'retweet',
      },
      {
        path: '/admin/plans',
        content: <div>Plans</div>,
        icon: 'schedule',
      },
      {
        path: '/admin/superlogin',
        exact: true,
        content: <div>Super Login</div>,
        icon: 'login',
      },
    ],
  };

  isActive = (path, exact) => {
    const {
      location: { pathname },
    } = this.props;

    if (exact) {
      return pathname === path;
    }

    return pathname.indexOf(path) === 0;
  };

  render() {
    const { userRole, withPadding, children } = this.props;

    return (
      <div className={s.root}>
        <div className={s.nav}>
          {this.routes[userRole].map(x => (
            <div
              className={`${s.route} ${
                this.isActive(x.path, x.exact) ? s.selected : ''
              }`}
              key={x.icon}
            >
              <Link to={x.path}>
                <div>
                  <div>
                    <Icon type={x.icon} />
                  </div>
                  {x.content}
                </div>{' '}
              </Link>
            </div>
          ))}
        </div>
        <div
          {...withPadding && { style: { padding: '15px' } }}
          className={s.content}
        >
          {children}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userRole: state.user.role,
});

export default withRouter(connect(mapStateToProps)(NavBar));
